<template>
    <v-card hover raised class="text-xs-center">
        <v-card-title primary-title>
            <h3 class="headline mb-0">Solicitudes de descuento</h3>
            <v-spacer></v-spacer>
            <slot name="opciones"></slot>
        </v-card-title>
        <v-card-text class="text-xs-left">
            <v-container fluid>
                <v-layout>
                    <v-flex xs12 justify-center align-center class="text-xs-center">
                        <v-progress-circular v-if="loading" :size="50" color="primary" indeterminate></v-progress-circular>
                    </v-flex>
                </v-layout>
            </v-container>
            <template v-for="(s,index) in solicitudes">
                <v-layout align-center>
                    <v-flex>
                        <span v-if="s.presupuesto.vendedor">Vendedor: <b>{{ s.presupuesto.vendedor.name }}</b></span>
                        <span v-if="s.presupuesto.usuario">Usuario: <b>{{ s.presupuesto.usuario.name }}</b></span>
                        <span v-if="s.presupuesto.distribuidor">Distribuidor: <b>{{ s.presupuesto.distribuidor.name }}</b></span>
                        <br>
                        Presupuesto:
                        <b>
                            <router-link exact :to="'/presupuesto/' + s.presupuesto_id">{{ s.presupuesto_id }}</router-link>
                        </b> |
                        Item:
                        <b>
                            <router-link exact :to="'/presupuesto/' + s.presupuesto_id + '/'+ s.item_tipo.cod +'/edit/' + s.id">{{ s.id }}</router-link>
                        </b> |
                        Cliente <b>{{ s.presupuesto.cliente.rzon_soc }}</b>
                        <br>
                        Importe: <b>{{ s.subtotal | moneda(s.presupuesto.moneda_id)}}</b>

                    </v-flex>
                    <v-flex>
                        <v-layout class="text-xs-center" justify-center align-center>
                            <v-flex v-if="s.sol_desc_com">
                                <div class="headline">Comercial</div>
                                <b class="headline">{{ s.sol_desc_com }}%</b>
                                <br>
                                <b>{{ s.subtotal - ((s.subtotal * s.sol_desc_com)/100) | moneda(s.presupuesto.moneda_id)}}</b>
                            </v-flex>
                            <v-flex v-if="s.sol_desc_est">
                                <div class="headline">Estratégico</div>
                                <b class="headline">{{ s.sol_desc_est }}%</b>
                                <br>
                                <b>{{ s.subtotal - ((s.subtotal * s.sol_desc_est)/100) | moneda(s.presupuesto.moneda_id)}}</b>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex>
                        <v-layout>
                            <v-flex>
                                <v-btn icon flat color="green" :loading="aceptando === s.id" @click="aceptar(index,s.id)">
                                    <v-icon>fa-thumbs-up</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex>
                                <v-btn icon flat color="red" :loading="rechazando === s.id" @click="rechazar(index,s.id)">
                                    <v-icon>fa-thumbs-down</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-divider></v-divider>
            </template>
        </v-card-text>
    </v-card>
</template>

<script>
    import mixinPresupItems from '../../mixins/presupuestoItems'
    import moneda from '../../filters/moneda';
    import {mapActions} from 'vuex';

    export default {
        name: "solicitudes-desc",
        mixins: [mixinPresupItems],
        filters: {moneda},
        data() {
            return {
                solicitudes: [],
                loading: false,
                aceptando: -1,
                rechazando: -1
            }
        },
        mounted() {
            this.datos();
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            datos() {
                this.loading = true;
                this.presupuestoItemSolicitudPendientes(r => {
                    if(r.txt){
                        this.msjShow(r);
                    }else{
                        this.solicitudes = r;
                    }
                    this.loading = false;
                }, err => {
                    this.loading = false;
                })
            },
            aceptar(indx, id) {
                this.aceptando = id;
                this.presupuestoItemSolicitudAprueba({id: id}, r => {
                    if (r.tipo === 'ok') {
                        this.solicitudes.splice(indx, 1);
                        this.aceptando = -1;
                    }
                }, err => {
                    this.aceptando = -1;
                })
            },
            rechazar(indx, id) {
                this.rechazando = id;
                this.presupuestoItemSolicitudRechaza({id: id}, r => {
                    if (r.tipo === 'ok') {
                        this.solicitudes.splice(indx, 1);
                        this.rechazando = -1;
                    }
                }, err => {
                    this.rechazando = -1;
                })
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/dashboard/SolicitudesDesc.vue